/**
 * Operational Bundle Viewer — Type Definitions
 *
 * Independent read-only viewer for OperationalBundleV1.
 */

import type { OperationalBundleV1, BundleVerificationResult } from '../server/export/operationalBundleTypes.js';
import type { OperationalWorkspaceState } from '../modules/governanceEventStream/operationalRendering/types.js';
import type { AttestationVerificationResult } from '../governanceWorkspace/attestation/operationalBundleAttestationTypes.js';
import type { OperationalLineageGraph, LineageVerificationResult } from '../governanceWorkspace/lineage/operationalLineageTypes.js';

export type ViewerPhase =
  | 'idle'          // Waiting for file input
  | 'loading'       // Parsing JSON
  | 'verifying'     // Running independent verification
  | 'valid'         // Bundle verified, replay rendered
  | 'invalid'       // Verification failed
  | 'error';        // Parse or runtime error

export interface ViewerState {
  phase: ViewerPhase;
  bundle: OperationalBundleV1 | null;
  workspace: OperationalWorkspaceState | null;
  verification: BundleVerificationResult | null;
  attestation: AttestationVerificationResult | null;
  lineageGraph: OperationalLineageGraph | null;
  lineageVerification: LineageVerificationResult | null;
  errorMessage: string | null;
}

export const INITIAL_VIEWER_STATE: ViewerState = {
  phase: 'idle',
  bundle: null,
  workspace: null,
  verification: null,
  attestation: null,
  lineageGraph: null,
  lineageVerification: null,
  errorMessage: null,
};
